import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';
import { getToken, isTokenExpired, updateToken } from './keycloak';

import type { RootState } from '../store';

const rawOrderkaroBaseQuery = fetchBaseQuery({
  baseUrl:
    import.meta.env.VITE_ORDERKARO_API_URL || 'https://orderkaro.sudosys.org',
  prepareHeaders: async (headers, { getState }) => {
    const state = getState() as RootState;
    const orgId = state.org?.selectedOrgId;

    if (orgId) {
      headers.set('X-Tenant-Id', orgId);
    }

    const _token = getToken();
    if (_token && !isTokenExpired()) {
      try {
        await updateToken(30);
        headers.set('Authorization', `Bearer ${getToken()!}`);
      } catch (error) {
        console.error('[orderkaroApiSlice] Token refresh failed:', error);
      }
    }
    return headers;
  },
});

const orderkaroBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  if (!getToken() || isTokenExpired()) {
    console.warn(
      '[orderkaroApiSlice] Request blocked — Keycloak not yet authenticated.'
    );
    return {
      error: {
        status: 'CUSTOM_ERROR',
        error: 'Keycloak not yet authenticated',
      } as FetchBaseQueryError,
    };
  }
  return rawOrderkaroBaseQuery(args, api, extraOptions);
};

export const orderkaroApiSlice = createApi({
  reducerPath: 'orderkaroApi',
  baseQuery: orderkaroBaseQuery,
  tagTypes: ['ShopVerification', 'ShopDocument'],
  endpoints: () => ({}),
});
